import styled from 'styled-components';
import { v2Colors, v2FontFamily } from './styles/tokens';

export const PlainCheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: ${v2FontFamily};
  font-size: 13.5px;
  font-weight: 500;
  color: ${v2Colors.textMuted};
  cursor: pointer;

  input {
    width: 14px;
    height: 14px;
    accent-color: ${v2Colors.primary};
    cursor: pointer;
  }
`;
